import { render, staticRenderFns } from "./View.vue?vue&type=template&id=3e4928fe"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=3e4928fe&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e4928fe')) {
      api.createRecord('3e4928fe', component.options)
    } else {
      api.reload('3e4928fe', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=3e4928fe", function () {
      api.rerender('3e4928fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/horizontal/View.vue"
export default component.exports